import {
    Box,
    Button,
    Flex,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
} from '@chakra-ui/react';
import { oBIcons } from '../components/Icons';
import { PlusSquareIcon } from '@chakra-ui/icons';
import { isEmpty } from 'lodash';
import StatusBadge from './StatusBadge';
import { formatDate } from 'utils/utils';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useGetTask } from 'hooks/useTask';

function TaskSummaryModal({ isOpen, onClose, task }) {
    if (!task) return null;
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent borderRadius="lg">
                <ModalHeader fontWeight="bold" color="#1B3B5F">
                    Task Summary
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontWeight="bold" fontSize="xl" mb={4}>
                        {task.title}
                    </Text>
                    <Box
                        as="dl"
                        display="grid"
                        gridTemplateColumns="1fr 1fr"
                        rowGap={3}
                        columnGap={4}
                        mb={6}>
                        <Text color="#667085">Task Owner</Text>
                        <Text textAlign={'right'}>{task?.Owner?.name}</Text>
                        <Text color="#667085">Due Date</Text>
                        <Text textAlign={'right'}>{formatDate(new Date(task.Due_Date))}</Text>
                        <Text color="#667085">Priority</Text>
                        <Box textAlign={'right'}>
                            <StatusBadge status={task.Priority?.toUpperCase()} />
                        </Box>
                        <Text color="#667085">Status</Text>
                        <Box textAlign={'right'}>
                            <StatusBadge status={task.Status?.toUpperCase()} />
                        </Box>
                        <Text color="#667085">Salesperson</Text>
                        <Text textAlign={'right'}>{task?.What_Id?.name}</Text>
                        <Text color="#667085">Contact</Text>
                        <Text textAlign={'right'}>{task.contact}</Text>
                        <Text color="#667085">Description</Text>
                        <Text textAlign={'right'}>{task.Description}</Text>
                        <Text color="#667085">Repeat Settings</Text>
                        <Text textAlign={'right'}>{task.repeat ? 'Enabled' : 'Disabled'}</Text>
                        <Text color="#667085">Reminder Settings</Text>
                        <Text textAlign={'right'}>{task.reminder ? 'Enabled' : 'Disabled'}</Text>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="white"
                        bg="#1b3b5f"
                        mr={3}
                        borderRadius="12px"
                        px={8}
                        fontWeight="bold">
                        Mark as Complete
                    </Button>
                    <Button
                        color="#1b3b5f"
                        bg="#B8C1D380"
                        borderRadius="12px"
                        px={8}
                        fontWeight="bold"
                        onClick={onClose}>
                        Edit Task
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

const Tasks = () => {
    const navigate = useNavigate();
    const [selectedTask, setSelectedTask] = useState(null);
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);

    const { tasks, isLoading } = useGetTask();

    return (
        <div>
            <Flex
                display={'flex'}
                flexDir={{ base: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={{ md: 'center' }}>
                <Flex gap="2" alignItems={'center'} color={'#1B3B5F'} fontWeight={'500'}>
                    {oBIcons.tasks}
                    <Text fontSize={{ base: 'lg', lg: 'xl' }}>MY TASKS</Text>
                </Flex>
                <Button
                    color="#1b3b5f"
                    bg="#B8C1D380"
                    mt="15px"
                    fontWeight="500"
                    borderRadius="8px"
                    h="48px"
                    fontSize={{ base: 'lg', lg: 'xl' }}
                    gap="2"
                    outline="none"
                    onClick={() => navigate('/dashboard/crm/create-task')}>
                    <PlusSquareIcon /> Create New Task
                </Button>
            </Flex>

            {isLoading ? (
                <Box>Loading...</Box>
            ) : !tasks || isEmpty(tasks) ? (
                <Box
                    minH={'40vh'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    color={'#667085'}>
                    No Avaliable Task
                </Box>
            ) : (
                <Box mt="5">
                    <TableContainer border="1px solid #EAECF0" borderRadius="lg">
                        <Table variant="simple" size="sm">
                            <Thead bg={'#F9FAFB'}>
                                <Tr>
                                    <Th textAlign={'center'} py="4">
                                        Title
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Due Date
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Status
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Priority
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {tasks?.map((task, i) => (
                                    <Tr
                                        fontSize="xs"
                                        key={task.id}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedTask(task);
                                            setIsSummaryOpen(true);
                                        }}>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {task?.Subject ?? 'N/A'}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            <Text>
                                                {task?.Due_Date
                                                    ? formatDate(new Date(task?.Due_Date))
                                                    : 'N/A'}
                                            </Text>
                                        </Td>

                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            <StatusBadge
                                                status={task?.Status?.toUpperCase() ?? 'PENDING'}
                                            />
                                        </Td>
                                        <Td py="4" textAlign={'center'}>
                                            <StatusBadge
                                                status={task?.Priority?.toUpperCase() ?? 'PENDING'}
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            )}
            <TaskSummaryModal
                isOpen={isSummaryOpen}
                onClose={() => setIsSummaryOpen(false)}
                task={selectedTask}
            />
        </div>
    );
};

export default Tasks;
